import { apiClient } from '../config/api';

export class AgendamentoService {
  static async list(params?: any) {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiClient.request<any>(`/agendamentos${qs}`);
  }

  static async get(id: number) {
    return apiClient.request<any>(`/agendamentos/${id}`);
  }

  static async create(payload: any) {
    return apiClient.request<any>(`/agendamentos`, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async update(id: number, payload: any) {
    return apiClient.request<any>(`/agendamentos/${id}`, { method: 'PUT', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async remove(id: number) {
    return apiClient.request<any>(`/agendamentos/${id}`, { method: 'DELETE' });
  }
}

export const agendamentoService = AgendamentoService;
